import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BillStatements from "./Billing/BillStatements";
import NewBill from "./Billing/NewBill";
import BillingConfig from "./Billing/BillingConfig";
import DatewiseBilling from "./Billing/DatewiseBilling";
import ChargeMasterManagement from "../Config/ChargeMasterManagement";
import classes from "./IPDBilling.module.css";
import { FaFileInvoice, FaPlus, FaHistory, FaCalendarAlt } from "react-icons/fa";

const IPDBilling = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("billStatement");

    return (
        <div className={classes.billingContainer}>

            {/* 🔹 Enhanced Tabs Section */}
            <div className={classes.tabsContainer}>
                <button
                    className={`${classes.tabBtn} ${activeTab === "billStatement" ? classes.activeTab : ""}`}
                    onClick={() => setActiveTab("billStatement")}
                >
                    <FaFileInvoice className={classes.tabIcon} /> {t("Billing Statement")}
                </button>
                <button
                    className={`${classes.tabBtn} ${activeTab === "newBill" ? classes.activeTab : ""}`}
                    onClick={() => setActiveTab("newBill")}
                >
                    <FaPlus className={classes.tabIcon} /> {t("New Bill")}
                </button>
                <button
                    className={`${classes.tabBtn} ${activeTab === "billingHistory" ? classes.activeTab : ""}`}
                    onClick={() => setActiveTab("billingHistory")}
                >
                    <FaHistory className={classes.tabIcon} /> {t("Billing History")}
                </button>
                <button
                    className={`${classes.tabBtn} ${activeTab === "datewiseBilling" ? classes.activeTab : ""}`}
                    onClick={() => setActiveTab("datewiseBilling")}
                >
                    <FaCalendarAlt className={classes.tabIcon} /> {t("Datewise Billing")}
                </button>
                <button
                    className={`${classes.tabBtn} ${activeTab === "chargeMaster" ? classes.activeTab : ""}`}
                    onClick={() => setActiveTab("chargeMaster")}
                >
                    <FaFileInvoice className={classes.tabIcon} /> {t("Charge Sheet")}
                </button>
            </div>

            <div className={classes.contentPanel}>
                {activeTab === "billStatement" && <BillStatements />}
                {activeTab === "newBill" && <NewBill />}
                {activeTab === "billingHistory" && <BillingConfig />}
                {activeTab === "datewiseBilling" && <DatewiseBilling />}
                {activeTab === "chargeMaster" && <ChargeMasterManagement />}
            </div>
        </div>
    );
};

export default IPDBilling;
